import SectionsContent from './SectionsContent';

export default SectionsContent;
